module.exports = __webpack_public_path__ + "img/pesanan-outline.8352e38f.svg";